import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class MailBoxListItem {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  login!: string;
  @IsNumber()
  @Expose()
  recordStampId!: number;
}

export class MailBoxListItemsResponse extends GenericTableResponse<MailBoxListItem> {
  @Expose()
  @IsArray()
  @Type(() => MailBoxListItem)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<MailBoxListItem>;
}
